import { render, staticRenderFns } from "./company-health-status.vue?vue&type=template&id=30201a5a&scoped=true&"
import script from "./company-health-status.vue?vue&type=script&lang=js&"
export * from "./company-health-status.vue?vue&type=script&lang=js&"
import style1 from "./company-health-status.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30201a5a",
  null
  
)

export default component.exports